import { QRCodeSVG } from "qrcode.react";
import { Reveal } from "./Reveal";
import { Star } from "./Logo";
import { useLang } from "@/i18n/LanguageContext";

const STORY_IMG = "/app-screens/tryon.webp?v=4";

export default function Social() {
  const { t, lang } = useLang();
  return (
    <section id="social" className="mx-auto max-w-7xl px-5 sm:px-8 py-24 sm:py-36" data-testid="social-section">
      <div className="grid grid-cols-1 items-center gap-16 lg:grid-cols-2">
        <Reveal className="order-2 lg:order-1 flex justify-center">
          <div
            className="relative w-[270px] sm:w-[300px] overflow-hidden rounded-[28px] border shadow-2xl"
            style={{ aspectRatio: "9/16", borderColor: "var(--line)" }}
            data-testid="story-card"
          >
            <img src={STORY_IMG} alt="Mira Mirror App: virtuelle Anprobe als KI-Vorschau (echter Screenshot)" className="absolute inset-0 h-full w-full object-cover object-top" />
            <div className="absolute top-3 left-3 flex items-center gap-2 rounded-full px-3 py-1.5 shadow-md backdrop-blur-md" style={{ background: "rgba(252,250,248,0.92)" }}>
              <Star size={12} />
              <span className="text-[10px] font-bold uppercase" style={{ letterSpacing: "0.12em" }}>{t.social.verified}</span>
            </div>
            <div className="absolute bottom-3 right-3 rounded-xl bg-white p-2 shadow-lg" data-testid="story-qr-code">
              <QRCodeSVG value="https://mira-mirror.ai" size={56} fgColor="#2C2725" bgColor="#FFFFFF" />
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.15} className="order-1 lg:order-2">
          <p className="flex items-center gap-2 text-xs uppercase font-medium" style={{ color: "var(--camel)", letterSpacing: "0.16em" }}>
            <Star size={11} /> {t.social.kicker}
          </p>
          <h2 className="mt-5 font-serif-display text-4xl sm:text-5xl font-semibold leading-tight" data-testid="social-title">
            {t.social.title}
          </h2>
          <p className="mt-6 max-w-md text-base md:text-lg leading-relaxed" style={{ color: "var(--muted-warm)" }}>
            {t.social.text}
          </p>
          <p className="mt-8 font-serif-display text-2xl italic" style={{ color: "var(--camel)" }}>
            {t.social.hashtags}
          </p>
          <p className="mt-3 text-xs uppercase" style={{ color: "var(--muted-warm)", letterSpacing: "0.14em" }}>
            ✦ {t.social.scan}
          </p>
        </Reveal>
      </div>
    </section>
  );
}
